// extracted by extract-css-chunks-webpack-plugin
module.exports = {"authorContainer":"_32FUlP"};